import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
    makeStyles,
} from '@material-ui/core';

import TaskForm from '../TaskForm';

const useStyles = makeStyles(() => ({
    taskForm: {
    },
}), { name: 'DefaultElementContent' });


const DefaultElementContent = ({
    element, task, className, taskResponses, contentState, onResponse, getProgramItem, getSpecificTaskResponses, showValidationErrors, TaskFormProps,
}) => {
    const classes = useStyles();

    return (
        <div className={classnames(className, classes.taskForm)}>
            <TaskForm
                element={element}
                taskResponses={taskResponses}
                contentState={contentState}
                onResponse={onResponse}
                getProgramItem={getProgramItem}
                getSpecificTaskResponses={getSpecificTaskResponses}
                taskId={task.id}
                showValidationErrors={showValidationErrors}
                {...TaskFormProps}
            />
        </div>
    );
}

DefaultElementContent.propTypes = {
    element: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    TaskFormProps: PropTypes.object,
    customElementHandler: PropTypes.func,
    onResponse: PropTypes.func.isRequired,
    LinkElementProps: PropTypes.object,
    taskResponses: PropTypes.object,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
    noHiddenStates: PropTypes.bool,
    HoveredElement: PropTypes.object,
    selectedElementId: PropTypes.number,
    addNoContextForImages: PropTypes.bool,
    elementPreContent: PropTypes.func,
    showValidationErrors: PropTypes.bool,
    className: PropTypes.string,
    contentState: PropTypes.string,
};

DefaultElementContent.defaultProps = {
    contentState: null,
    TaskFormProps: null,
    customElementHandler: null,
    LinkElementProps: null,
    taskResponses: null,
    noHiddenStates: false,
    HoveredElement: null,
    selectedElementId: null,
    addNoContextForImages: false,
    elementPreContent: null,
    showValidationErrors: false,
    className: null,
};

export default DefaultElementContent;
